import { create } from "zustand";

export interface DialogHeader {
  title: string;
  icon?: "triangle-alert" | "info";
  description?: string;
}

export interface DialogFooter {
  actions?: React.ReactNode;
  hint?: string;
}

export interface DialogConfig {
  header: DialogHeader;
  content: React.ReactNode;
  footer?: DialogFooter;
}

interface DialogState {
  isOpen: boolean;
  header: DialogHeader | null;
  content: React.ReactNode | null;
  footer: DialogFooter | null;
  openDialog: (config: DialogConfig) => void;
  closeDialog: () => void;
}

export const useDialogStore = create<DialogState>((set) => ({
  isOpen: false,
  header: null,
  content: null,
  footer: null,
  openDialog: (config) =>
    set({
      header: config.header,
      content: config.content,
      footer: config.footer ?? null,
      isOpen: true,
    }),
  closeDialog: () =>
    set({ header: null, content: null, footer: null, isOpen: false }),
}));
